import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { TrustedSourceItem, UpsertTrustedSourceRequest } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function upsertTrustedSource(data: UpsertTrustedSourceRequest): Promise<TrustedSourceItem> {
  return api.post("/trusted-source", data)
}

export function useUpsertTrustedSource() {
  const queryClient = useQueryClient()

  const upsertTrustedSourceMutation = useMutation({
    mutationKey: queryKeys.upsertTrustedSource,
    mutationFn: (data: UpsertTrustedSourceRequest) => upsertTrustedSource(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.trustedSources })
    },
  })

  return upsertTrustedSourceMutation
}
